import { Component, ElementRef, OnInit, Renderer2, Inject } from '@angular/core'
import { DOCUMENT } from '@angular/common'
import { NuclearObservable } from '../nuclear-observable'
import { environment } from './../environments/environment'
import { BaseComponent } from '../components/base.component'
import { customerGetters } from '../stores/customer-store'
import { Plan } from '../types'
import { PlanActions } from '../actions/plan-actions'

/**
 * Page to iframe pricing.
 * Access at /pricing.
 * window.parent refers to the page hosting the iframe
 */

@Component({
  selector: 'pricing-page',
  template: `
    <multipass-plan-form
      [customerId]="null"
      (onSubmitwww)="submitted($event)"></multipass-plan-form>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class PricingPage extends BaseComponent implements OnInit {
  plans: Plan[] = []

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: any,
    private planActions: PlanActions
  ) {
    super()
  }

  ngOnInit(): void {
    let script = this.renderer.createElement('script')
    script.type = 'text/javascript'
    script.src = '//cdn-3.convertexperiments.com/js/10005965-10006363.js'
    this.renderer.appendChild(this._document.body, script)

    this.planActions.loadPlans().then(() => {
      setTimeout(() => this.notifyParentOfHeight(), 500)
    })
    const planObs = NuclearObservable.from<Plan[]>(customerGetters.plans, { toJS: true }).subscribe(
      (ps) => {
        this.plans = ps
      }
    )

    this.observers.push(planObs)

    if (window.parent) {
      window.addEventListener('resize', () => {
        this.notifyParentOfHeight()
      })
    }
  }

  notifyParentOfHeight(): void {
    this.postMessageToParent({ iframe: { height: this.contentHeight() } })
  }

  postMessageToParent(msg: object): void {
    window.parent.postMessage(msg, '*')
  }

  contentHeight(): number {
    const e = this.elementRef.nativeElement
    return Math.max(e.scrollHeight, e.offsetHeight)
  }

  submitted(email: string): void {
    const msgParent = () =>
      this.postMessageToParent({ iframe: { submitted: encodeURIComponent(email) } })
    msgParent()
  }

  showForm(): boolean {
    return this.plans && this.plans.length > 0
  }
}
